/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'
import {environment} from './environment';
import { getToken } from '@/utils/auth'
import { getTime } from './api/settings';
import moment from "moment";
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store'

// Error Logger
import Logger from './logger';

// Vuexy Admin Filters
import './filters/filters'

// mock
import './fake-db/index.js'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// i18n
import i18n from './i18n/i18n'
import validationMessages from './i18n/validations/index' 

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
  i18nRootKey: 'VALIDATIONS', // customize the root path for validation messages.
  i18n
})

//moment for date
Vue.use(require('vue-moment'))

// sweetalert
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// vue debounce
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce, {
	defaultTime: '500ms',
	fireOnEmpty: true
})

// Custom CSS
import '@/assets/css/custom.css'

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

Vue.config.productionTip = false

// Use logger
Vue.use(Logger);

Vue.prototype.$eventHub = new Vue(); // Global event bus

// Vue Tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import Echo from "laravel-echo"
window.io = require('socket.io-client');

window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: environment.websocket_host,
  auth: {headers: {Authorization: null, "User-Agent": navigator.userAgent}}
});

// global filters
Vue.filter('displayName', v=>{
  return v ? v.first_name + ' ' + v.last_name : '';
});
Vue.filter('displayEmail',v => {
  return v ? v.email : Math.floor(Math.random() * 1000) + "@concilium.cloud";
});
Vue.filter('displayDate',v => {
  if (v) {
    const data = moment(v).calendar({
      sameDay: "[Today] HH:mm",
      lastDay: "[Yesterday] HH:mm",
      lastWeek: "dddd HH:mm",
      sameElse: "DD MMM YYYY HH:mm",
    });
    return data;
  }
  return v
});
Vue.filter('displayOnlyDate',v => {
  if (v) {
    const data = moment(v).calendar({
      sameDay: "[Today]",
      lastDay: "[Yesterday]",
      lastWeek: "dddd",
      sameElse: "DD MMM YYYY",
    });
    return data;
  }
  return v
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
		computed: {
			isSocketConnected() {
				return this.$store.state.auth.isSocketConnected
			}
		},
		watch: {
			isSocketConnected(isSocketConnected) {
				if(!isSocketConnected)
					this.$store.commit('SET_EVENT_PARTICIPANTS_OFFLINE');
			}
		},
    created() {
			const vm = this;
			window.Echo.connector.socket.on('disconnect', function () {
				vm.$store.commit('SET_IS_SOCKET_CONNECTED', false);
			});
			window.Echo.connector.socket.on('connect', function () {
				vm.$store.commit('SET_IS_SOCKET_CONNECTED', true);
			});
      this.authInit();
    },
methods: {
	authInit() {
		this.$store.commit('SET_USER_IP_ADDR');
		const token = store.getters.token;
		if (token) {
			this.$store.commit('SET_TOKEN', token);
			this.$store.commit('SET_USER', store.getters.currentUser);
			this.$store.commit('SET_USER_ACTIVE_CHANNEL');
		}
	},
	async serverTimeInit() {
		try{
		const res = await getTime();
		const dt = new Date();
		const diffTime = dt.getTime() - res.data.timestamp;
		this.$store.commit('SET_SERVER_TIME_DIFFERENCE', diffTime);
		}catch(error){
			console.log('--CAUGHT SERVER TIME ERROR--')
			console.error(error);
		}
	}
}
}).$mount('#app')

import '@/assets/js/pleaserotate.min.js'
/*var PleaseRotateOptions = {
  message: "Per favore ruota il tuo telefono",
  subMessage: "Grazie",
  allowClickBypass: true
};
PleaseRotate.start(PleaseRotateOptions);*/
